/* eslint-disable */
import axios from 'axios'

const profile = {
    namespaced:true,
        state: {
            info:[],
            imageInfo:[],
        },
        getters: {},
        actions: {
            GET_PROFILE: async ({commit}) => {
                let { data } = await axios.get(`api/getemployeeinfo`)
                commit('SET_PROFILE', data)
            },

            GET_IMAGE: async ({commit}) => {
                let { data } = await axios.get(`api/imageupload`)
                commit('SET_IMAGE', data)
            },
        },
        mutations: {  
            SET_PROFILE: (state, payload) => {
                state.info = payload
            },

            SET_IMAGE: (state, payload) => {
                state.imageInfo = payload
            },
    
        }
}

export default profile 


// WEBPACK FOOTER //
// ./src/modules/userProfile.js